import {data} from 'jquery';
import {fetchJSON, fetchPOST, fetchPOSTjson} from '../Tools';

/**
 * Dieses Modul implementiert die Logik für das erstellen und bearbeiten von
 * Diagrammbereichen (zur farbigen Hinterlegung)
 */
export class DiagramArea {
    /**
     * Die Url zum Persistieren der Bereichs-Einträge
     * @private
     */
    private static updateUrl = '/diagramarea/update';

    /**
     * Die Url zum Persistieren der Bereichs-Einträge
     * @private
     */
    private static deleteGroupUrl = '/diagramarea/deleteGroup';

    /**
     * Die Url zum Abfragen der Bereichseinträge
     * @private
     */
    private static listUrl = '/diagramarea/list';
    /**
     * Die Url zum Abfragen der Parameter für eine Station
     * @private
     */
    private static parameterListUrl = '/fews/parameter/list';

    /**
     * Die Buttons, mit denen der Dialog für eine spezielle Station geöffnet wird
     * @private
     */
    private editDiagramAreaButtons: NodeListOf<Element>;
    /**
     * Löschen von Gruppen
     * @private
     */
    private deleteGroupButtons: NodeListOf<Element>;

    /**
     * Der Dialog
     * @private
     */
    private dialog: JQuery<HTMLElement>;

    /**
     * Die aktuelle Stations-Id
     * @private
     */
    private stationId: string;

    /**
     * Die aktuelle Stations-Art
     * @private
     */
    private stationType: string;

    /**
     * Die Vorlage für neue Einträge.
     * @private
     */

    private template: JQuery<HTMLElement>;
    /**
     * Der Bereich im Dialog, in dem neue Einträge eingefügt werden
     * @private
     */
    private inner: JQuery<HTMLElement>;

    /**
     * Container für den Namen der Gruppe
     */
    private groupElement: HTMLElement;

    /**
     * Container für den Namen der Gruppe
     */
    private groupLabel: HTMLInputElement;

    constructor() {
        this.editDiagramAreaButtons = document.querySelectorAll('.edit-diagramArea');
        this.deleteGroupButtons = document.querySelectorAll('.js-delete-diagramArea i');

        // Wenn es keine Buttons gibt, brich ab.
        if (!this.editDiagramAreaButtons.length) {
            return;
        }

        // Erzeuge den Dialog.
        const _this = this;
        this.dialog = $('#stationDiagramAreaDialog').dialog({
            autoOpen: false,
            modal: true,
            width: 640,
            title: 'Diagrammbereiche',
            height: 640,
            maxHeight: 640,
            buttons: [
                {
                    text: 'Speichern',
                    class: 'ok',
                    click: function (event) {
                        _this.updateData.call(_this, event);
                    },
                },
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function () {
                        $(this).dialog('close');
                    },
                },
            ],
        });
        this.template = this.dialog.find('.diagramarea-item').first();
        this.inner = this.dialog.find('.diagramarea-inner');
        this.groupElement = this.dialog[0].querySelector('.js-diagramarea-group-label');
        // Wenn es kein Template oder Einfügebereich gibt, brich ab.
        if (null == this.template || null == this.inner) {
            return;
        }

        // Füge die Event-Handler für die Buttons hinzu.
        this.editDiagramAreaButtons.forEach((button: HTMLElement) => {
            this.registerButton(button);
        });
        this.dialog.find('.add').on('click', () => this.addArea.call(this));
        window.addEventListener('registerAreaClick', (event: CustomEvent) => {
            this.registerButton(event.detail.item);
        });
        this.deleteGroupButtons.forEach((button: HTMLElement) => {
            button.addEventListener('click', () => this.deleteGroup(button));
        });
    }

    deleteGroup(button: HTMLElement) {
        if(confirm('Wollen Sie die Gruppe wirklich löschen?')) {
            const groupId = button.dataset.groupId;
            fetchPOSTjson(DiagramArea.deleteGroupUrl, {
                groupId: groupId,
                action: 'DELETE'
            }, true).then((data) => {
                if (data.succsess) {
                    // Zeile löschen
                    button.closest('.list-row').remove();
                }
            });
        }
    }

    registerButton(button: HTMLElement) {
        if (typeof button === 'object') {
            button.querySelector('i').addEventListener('click', (event) => {
                if (button.querySelector('i')?.dataset.editmode) {
                    const selectedStationId = (<HTMLInputElement>button.closest('.cms-input')?.querySelector('input.data-id')).value;
                    button.querySelector('i').dataset.stationId = selectedStationId;
                }
                this.showDialog.call(this, event);
            });
        }
    }

    /**
     * Ruft die Logik auf, die beim Klick auf einen Button zum öffnen des Dialogs nötig ist.
     * @param event
     */
    async showDialog(event: MouseEvent) {
        // Vorbereiten
        const target = event.target as HTMLElement;
        this.stationId = target.dataset.group || target.dataset['stationId'];
        this.stationType = target.dataset.groupId || target.dataset['stationType'];
        this.groupElement.classList.add('d-none');

        if (target.dataset.groupName) {
            this.groupElement.classList.remove('d-none');
            this.groupLabel = <HTMLInputElement>this.groupElement.querySelector('input#diagramarea-group-label');
            this.groupLabel.value = target.dataset.groupName;
            this.groupLabel.dataset.default = target.dataset.groupName;
        }
        // Parameter für diese Station holen
        const parametersByStationRequest = fetchJSON(DiagramArea.parameterListUrl + '/' + this.stationId + '/' + this.stationType);
        parametersByStationRequest.then((data) => {
            const parameterTypeSelect = this.dialog[0].querySelector('#parametertype-select');
            parameterTypeSelect.innerHTML = '<option value="">Bitte wählen</option>';

            const template = document.createElement('option');
            new Map(Object.entries(data)).forEach((param: Parameter) => {
                const current = template.cloneNode(true) as HTMLOptionElement;
                current.value = param.type;
                current.innerText = param.value;
                parameterTypeSelect.insertAdjacentElement('beforeend', current);
            });

            // Dialog anzeigen, wenn das parameter-request beendet ist.
            this.dialog.dialog('open');
        });

        // Diagrammbereiche für diese Station holen
        let url = DiagramArea.listUrl + '/' + this.stationId + '/' + this.stationType + '/null/' + (target.dataset.groupName ? '0' : '1') + '/';
        // Daten Parsen, wenn das diagramm-request erfolgreich war.
        fetchJSON(url).then((data) => {
            this.parseData.call(this, data);
        });
    }

    /**
     * Fügt ein neues Fieldset für einen neuen Diagrammbereich zum Dialog hinzu.
     */
    public addArea() {
        // Leeren Modell erstellen
        let item = new DiagramAreaDTO();
        item.id = 0;
        item.minY = 0;
        item.maxY = 0;
        item.label = 'neu';
        item.stationId = this.stationId;
        item.stationType = this.stationType;
        item.parameterType = '';
        item.style = '';

        // Fieldset erstellen und anzeigen
        let $clone = this.prepareFromTemplate(this.template, item);
        $clone.show('highlight');
        this.inner.append($clone);

        // Wenn der Eintrag noch nicht gespeichert ist,
        // kann er einfach geleert werden um ihn nicht zu persistieren
        $clone.find('.remove').on('click', () => $clone.html(''));
    }

    public toggleGroupSelect(showGroup = false, reload = true) {
        if (showGroup) {
            this.dialog[0].querySelectorAll('.js-disabled-on-group').forEach((element) => {
                element.classList.add('d-none');
            });
            this.dialog[0].querySelectorAll('.js-enabled-on-group').forEach((element) => {
                element.classList.remove('d-none');
            });
            this.inner.html('');
            return false;
        } else {
            this.dialog[0].querySelectorAll('.js-disabled-on-group').forEach((element) => {
                element.classList.remove('d-none');
            });
            this.dialog[0].querySelectorAll('.js-enabled-on-group').forEach((element) => {
                element.classList.add('d-none');
            });
            if (reload) {
                fetchJSON(DiagramArea.listUrl + '/' + this.stationId + '/' + this.stationType + '/null/0/').then((data) => {
                    this.parseData(data);
                });
            }
        }
        return true;
    }

    /**
     * Lies die Daten aus, die das Diagramm-Bereich-Request zurückgegeben
     * hat und stellt diese in Field-sets im dialog dar.
     * @param data Die Antwort vom Request.
     */
    public parseData(data: any) {
        this.inner.html('');
        this.toggleGroupSelect(false, false);
        // Einfügebereich leeren.

        // Für jeden Eintrag in Data ein neues Fieldset einfügen
        for (const [index, item] of Object.entries(data)) {
            const $current: JQuery<HTMLElement> = this.prepareFromTemplate(this.template, item as DiagramAreaDTO);
            // Event listener für den Löschbutton registrieren
            $current.find('.remove').on('click', () => this.deleteItem.call(this, $current));

            // Anzeigen
            this.inner.append($current);
            $current.show('highlight');
        }
    }

    /**
     * Eintrag als zu löschend markieren.
     * @param $item das Fieldset für den Eintrag
     * @private
     */
    private deleteItem($item: JQuery<HTMLElement>) {
        // Hidden Input im Fieldset finden.
        const $stationIdInput = $item.find('input[type="hidden"][name$="-stationId"]');

        // Input-Element mit der Aktion hinzufügen.
        const inputName = $stationIdInput.attr('name').replace('stationId', 'action');
        $stationIdInput.after(`<input type="hidden" name="${inputName}" value="DELETE">`);

        // Fieldset ausblenden.
        $item.hide();
    }

    /**
     * Ein Fieldset aus der Vorlage für einen Eintrag erstellen.
     * @param $template Die Vorlage.
     * @param item Der Eintrag.
     * @private
     */
    private prepareFromTemplate($template: JQuery<HTMLElement>, item: DiagramAreaDTO) {
        const $current = $template.clone();
        // Identifikator setzen, je nachdem, ob es sich um einen neuen oder persistierten Eintrag handelt
        const itemId = item.id !== 0 ? item.id : 'NEW_' + Math.random().toString(36).substr(2, 5);

        // Für jede Eigenschaft des Eintrags die jeweiligen Eingabefelder anpassen.
        for (const [property, value] of Object.entries(item)) {
            // for-Attribut der Label setzen
            $current.find(`.diagramarea-${property} label`).first().attr('for', `${itemId}-${property}`);

            // Folgende Attribute für das jeweilige Input-Element setzen
            //   name, data-default, value
            if ('parameterType' == property) {
                $current.find(`.diagramarea-${property} select`).data('default', value).attr('name', `${itemId}-${property}`).attr('id', `${property}-${itemId}`);
                // Ausgewählte Option für Select setzen
                $current.find(`.diagramarea-${property} select option[value='${value}']`).attr('selected', 'selected');
            } else {
                $current.find(`.diagramarea-${property} input`).first().attr('name', `${itemId}-${property}`).data('default', value).val(value);
            }
        }

        // neues Fieldset zurückgeben
        return $current;
    }

    /**
     * Holt die geänderten Daten aus den Input-Elementen und übergibt diese ans Backend
     * @param event das auslösende Event
     * @private
     */
    private updateData(event: MouseEvent) {
        // Map von Einträgen gruppiert nach Identifikator (id oder 'NEW_xxx')
        var map = new Map<string, DiagramAreaDTO>();

        // Alle Input/Select-Elemente im Formular
        this.inner
            .find('*')
            .filter(':input')
            .each((index, element) => {
                if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                    const $el = $(element);
                    // Prüfe, ob ein die Eigenschaft geändert oder neu ist.
                    const itemIsNew = $el.attr('name').startsWith('NEW_') || $el.data('default') === undefined;

                    let itemHasChanged = false;
                    // Prüfe, ob der aktuelle Wert im Vergleich zum geladenen geändert wurde.
                    if (!itemIsNew && $el.val()) {
                        itemHasChanged = $el.val().toString().toLowerCase() !== $el.data('default').toString().toLowerCase();
                    }
                    if (itemIsNew || itemHasChanged) {
                        // ID und Eigenschaft aus dem Input-Element holen.
                        const [id, prop] = $el.attr('name').split('-');

                        // Element hervorheben
                        $el.show('highlight');

                        // Geänderte Werte in der Map speichern
                        let diagramAreaDTO = new DiagramAreaDTO();
                        if (map.has(id)) {
                            diagramAreaDTO = map.get(id);
                        } else {
                            diagramAreaDTO.id = parseInt(id);
                        }
                        diagramAreaDTO[prop] = $el.val();
                        map.set(id, diagramAreaDTO);
                    }
                }
            });


        // Brich ab, wenn keine Änderungen stattgefunden haben.
        if (map.size == 0 && this.groupElement.dataset.default === this.groupLabel.value) {
            return;
        }

        // Auslösendes HTML-Element ändern.
        const buttonHtml = (<HTMLElement>event.target).innerHTML;
        (<HTMLElement>event.target).innerHTML = '<i class="icon-spin5"></i>';

        // Änderungen übertragen
        let json = <any>Array.from(map.values());
        if (this.stationId === 'GROUP') {
            (<Array<IDictionary>>json).push({
                groupName: this.groupLabel.value,
                groupId: this.stationType,
            });
        }

        const updateRequest = fetchPOSTjson(DiagramArea.updateUrl, json);
        updateRequest.then((data) => {
            if (data && parseInt(data) > 0) {
                this.stationType = data;
            }
            (<HTMLElement>event.target).innerHTML = buttonHtml;
        });
    }
}

class Parameter {
    public type: string;
    public value: string;
}

class DiagramAreaDTO {
    public id: number;
    public label: string;
    public style: string;
    public stationId: string;
    public stationType: string;
    public parameterType: string;
    public minY: number;
    public maxY: number;
}
